export function debounce(fn: Function, delay: number) {
  let timeoutID: ReturnType<typeof setTimeout> | undefined;
  return function (...args: any[]) {
    clearTimeout(timeoutID);
    timeoutID = setTimeout(() => {
      fn.apply(this, [...args, timeoutID]);
    }, delay);
    return timeoutID;
  };
}

// Use this method if you have multiple debounces in a single page, where they overwrite eachother
// First parameter of the debounced function is the unique debounce key
export function debounceUnique(fn: Function, delay: number) {
  const timeouts = new Map<string, ReturnType<typeof setTimeout>>();

  return function (key: string, ...args: any[]) {
    if (args.length === 0) args = [key];

    const existingTimeout = timeouts.get(key);
    if (existingTimeout) {
      clearTimeout(existingTimeout);
    }

    const timeoutID = setTimeout(() => {
      fn.apply(this, [key, ...args]);
      timeouts.delete(key);
    }, delay);

    timeouts.set(key, timeoutID);
    return timeoutID;
  };
}
